import { FetchCompanyTabsSortTypes } from './companyTabsTypes';

export const INITIAL_COMPANY_TABS_FILTERS = {};

export const INITIAL_COMPANY_TABS_LIMIT = 50;

export const INITIAL_COMPANY_TABS_PAGE = 1;

export const INITIAL_COMPANY_TABS_SORT = [
  FetchCompanyTabsSortTypes.POSITION_ASC
];
